import {Typography} from '~library/atoms/Typography';
import {PlusIcon} from '~library/svg/PlusIcon';
import {useIsMediumAndUp} from '~/common/hooks/useMatchQuery';
import {PhotoUploadButton} from '~/ViewInvitation/routes/Landing/PhotoUploadButton';
import {white} from '~libSass/base/_exports.sass';

import './PhotosEmptyState.sass';

const EMPTY_STATE_IMG =
  'https://g0.evitecdn.com/invitation/designs/host-photo-module-empty-state.png';

export const PhotosEmptyState = ({
  showAddButton = false,
  isCreationFlow = false,
  emptyStateText = '',
  handlePost = () => {},
  collection = 'photos',
  fileUploadRef = null,
}) => {
  const isMediumAndUp = useIsMediumAndUp();

  return (
    <div className={`photos-empty-state photos-empty-state--${isCreationFlow ? 'create' : 'view'}`}>
      <img className="photos-empty-state__img" src={EMPTY_STATE_IMG} alt="empty state icon" />
      <Typography
        variant="paragraph1"
        color={isCreationFlow ? 'asphalt' : 'pebble'}
        data-qa-id="host-photos-module-empty-state-description"
      >
        {emptyStateText}
      </Typography>
      {!isCreationFlow && showAddButton && (
        <PhotoUploadButton
          largeButton={isMediumAndUp}
          collection={collection}
          handlePost={handlePost}
          fileUploadRef={fileUploadRef}
          disabled={false}
        >
          Add photos
        </PhotoUploadButton>
      )}
    </div>
  );
};
